export default function useRoundNumber(number, numDigits) {
  if (!Number.isFinite(number) || numDigits < 0 || numDigits > 10) {
    return NaN;
  }
  return +(`${Math.round(`${number}e+${numDigits}`)}e-${numDigits}`);
}
